module.exports = __webpack_public_path__ + "media/src/components/Home/FeaturedInSection/kiripost-2b1a7c7aa7190abc575d235aa88363f4.png";